import { FC, useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PinInput from 'react-pin-input'

import { fetchStart } from '../../../../redux/actions/common'

import { Modal } from 'react-bootstrap-v5'
import { OtpIcon } from '../../../../svg/OtpIcon'
import UserVerification from '../UserCompanyVerification'
import { setOpenVerification, setSubStep } from '../redux/actions'
import { Alert, Snackbar } from '@mui/material'

const Step1Sub2: FC<any> = ({
  mobileNo,
  sendOTP,
  validateOTP,
  id,
  show,
  handleClose,
  email,
  otpMethod,
}) => {
  const dispatch = useDispatch()

  const [otp, setOtp] = useState<any>('')
  const openVerification = useSelector((state: any) => state.coApplicant.openVerification)
  const [countdown, setCountdown] = useState<number>(40);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' })
  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )
  const pinInputRef = useRef<any>(null)

  // const [validateOTPMutation, { data, loading, error }] = useMutation(mutations.VALIDATE_OTP, { variables: { otp: otp, mobileNo: localStorage.getItem("mobileNo"), isApplicantOrShareholder: true } });

  useEffect(() => {
  let timer: NodeJS.Timeout;
  if (countdown > 0) {
    timer = setTimeout(() => setCountdown(countdown - 1), 1000);
  }

  return () => clearTimeout(timer);
}, [countdown]);
  
  const handlePaste = (e: React.ClipboardEvent) => {
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '')
    if (pastedData.length === 6) {
      pinInputRef.current.values = pastedData.split('')
      pinInputRef.current?.focus()
      setOtp(pastedData)
    }
    e.preventDefault()
  }

  const resendOTP = () => {
    dispatch(fetchStart())
    setOtp('')
    // Clear the PIN input boxes
    if (pinInputRef.current) {
      pinInputRef.current.clear()
    }
    sendOTP({
      variables: {
        mobileNo,
        isApplicantOrShareholder: true,
        isCoApplicantKYB: true,
        id: id,
        type: otpMethod === 'email' ? 'email' : 'mobile',
      },
    })
    showSnackbar("OTP re-sent Successfully")
  }

  // const submitOTP = () => {
  //   if (otp.length === 6) {
  //     dispatch(fetchStart());
  //     validateOTP({
  //       variables: {
  //         otp,
  //         mobileNo,
  //         isApplicantOrShareholder: false,
  //         applicantId: id
  //       }
  //     })
  //   }
  // }

  const onSubmitOTP = (otp: string) => {
    dispatch(fetchStart())
    validateOTP({
      variables: {
        otp,
        mobileNo,
        isApplicantOrShareholder: true,
        id: id,
        type: otpMethod === 'email' ? 'email' : 'mobile',
      },
    })
  }

  const showSnackbar = (message: string, severity?: string) => {
    setSnackbar({ open: true, message: message, severity: severity || 'success' })
  }

  const handleCloseSnackbar = () => {
    setSnackbar({ open: false, message: '', severity: 'success' })
  }

  const phoneNumber = mobileNo && mobileNo.replace('65', '').replace(/\D/g, '')
  const maskEmail = (email: string) => {
    if (!email) return ''
    const [localPart, domain] = email.split('@')
    if (localPart.length <= 2) return email
    const visiblePart = localPart.substring(0, 2)
    const maskedPart = '*'.repeat(localPart.length - 2)
    return `${visiblePart}${maskedPart}@${domain}`
  }
  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        dialogClassName='modal-dialog-centered'
        show={show}
        onHide={handleClose}
        centered
        size='lg'
      >
        <div
          className='d-flex flex-column flex-center flex-column-fluid'
          style={{ minHeight: 'auto' }}
        >
          <div className='d-flex flex-column align-items-center p-10'>
            {/* Heading and Sub-Text */}
            <OtpIcon />
            <h2 className='section-heading fs-2 text-center verification'>Verification</h2>
            <div
              style={{ fontSize: '18px', color: '#757575' }}
              className='text-gray-400 mb-5 text-center'
            >
              {otpMethod === 'email' ? (
                <>Enter the verification code we sent to {maskEmail(email)}</>
              ) : (
                <>
                  Enter the verification code we sent to +65{' '}
                  {phoneNumber.replace(/\d(?=.*\d{4})/g, '*')}
                </>
              )}
            </div>
            {/* Enter Code */}
            <div className='w-100 mb-4 text-start' onPaste={handlePaste}>
              <div className='fs-4 eCode'>Enter Code</div>
              <PinInput
                ref={pinInputRef}
                length={6}
                initialValue=''
                secret
                focus={true}
                onChange={(value, index) => setOtp(value)}
                type='numeric'
                inputMode='number'
                style={{ borderRadius: '4px !important' }}
                inputStyle={{ borderColor: '#E8EAEB' }}
                inputFocusStyle={{ borderColor: '#E8EAEB' }}
                // onComplete={(value, index) => onSubmitOTP(value)}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
            </div>

            {/* Resend Code Section */}
            <div className='w-100 mb-10 text-start fs-6'>
              {(
                <>
                  Didn't get the code?{' '}
                  <button
                    type='button'
                    className={`btn btn-link p-0 border-0 text-primary-dark ${countdown > 0 ? 'text-muted' : 'text-decoration-underline'}`}
                    onClick={() => {
                      resendOTP();
                      setCountdown(40);
                    }}
                    disabled={countdown > 0}
                  >
                    Resend Code {countdown > 0 ? `in ${countdown} ${countdown === 1 ? "second" : "seconds"}` : ''}
                  </button>
                </>
              )}
            </div>

            {/* Action Buttons (Verify & Back) */}
            <div className='d-flex flex-column gap-4 w-100 mb-10 justify-content-between'>
              <button
                type='button'
                className='button button-primary'
                disabled={otp.length < 6} // Disable until OTP is filled
                onClick={() => onSubmitOTP(otp)}
              >
                Verify
              </button>
              <div className='line d-flex justify-content-center text-muted'>
                <span className='zIndex-1'>OR</span>
              </div>

              {/* Back Button */}
              <button
                type='button'
                className='button button-outline-back'
                onClick={handleClose} // Handle back action here
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </Modal>

      {openVerification && (
        <UserVerification
          show={openVerification}
          handleClose={() => {
            dispatch(setOpenVerification(false))
            if (companyVerificationMethod === 1) {
              dispatch(setSubStep(2))
            } else {
              dispatch(setSubStep(3))
            }
          }}
          goToStep={() => {
            dispatch(setSubStep(2))
          }}
        />
      )}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        autoHideDuration={3000}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity as any ?? 'success'} variant='filled'>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  )
}

export { Step1Sub2 }
